import Link, { LinkProps } from 'next/link';

interface ConditionalLinkProps extends LinkProps {
  condition: boolean;
  children: React.ReactNode;
}

const ConditionalLink: React.FC<ConditionalLinkProps> = ({ condition, ...props }) => {
  if (!condition) return <>{props.children}</>;
  return (
    <Link {...props}/>
  );
}

export default ConditionalLink;